import { useState } from 'react';

export const useTableState = (initialSearchQuery?: string, updateSearchQuery?: (query: string) => void) => {
  const [selectedSubstitutes, setSelectedSubstitutes] = useState<string[]>([]);
  const [hiddenAssetIds, setHiddenAssetIds] = useState<Set<string>>(new Set());
  const [showSearchInput, setShowSearchInput] = useState(false);
  const [localSearchQuery, setLocalSearchQuery] = useState(initialSearchQuery || '');

  const handleSubstituteToggle = (assetId: string) => {
    setSelectedSubstitutes(previous => {
      return previous.includes(assetId) ? previous.filter(id => id !== assetId) : [...previous, assetId];
    });
  };

  const handleHideAsset = (assetId: string) => {
    setHiddenAssetIds(previous => new Set(previous).add(assetId));
  };

  const handleSearchChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setLocalSearchQuery(event.target.value);
  };

  const handleClearSearch = () => {
    setLocalSearchQuery('');
    setShowSearchInput(false);
    updateSearchQuery?.('');
  };

  const handleSearchClick = () => {
    setShowSearchInput(true);
  };

  return {
    selectedSubstitutes,
    hiddenAssetIds,
    showSearchInput,
    localSearchQuery,
    setShowSearchInput,
    setLocalSearchQuery,
    setHiddenAssetIds,
    handleSubstituteToggle,
    handleHideAsset,
    handleSearchChange,
    handleClearSearch,
    handleSearchClick,
  };
};
